import { Grid, Typography } from "@material-ui/core";

import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import { useAdminConsulta } from "../../../../context/AdminConsultaContext";

export default function CancelarConsulta() {
    const {
        consultaSeleccionada,
        modalOpenCancelarConsulta,
        handleOpenCancelarConsultar,
        handleSubmitCancelarConsulta,
    } = useAdminConsulta();

    return (
        <MeditocModal
            title="Cancelar consulta"
            open={modalOpenCancelarConsulta}
            setopen={handleOpenCancelarConsultar}
            okfunc={handleSubmitCancelarConsulta}
            cancelMessage="Cerrar"
            align="center"
            size="small"
        >
            <Grid container spacing={1} className="center">
                <Grid item xs={12}>
                    <Typography paragraph align="center">
                        ¿Desea cancelar la siguiente consulta?
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {!consultaSeleccionada.iIdUsuario ? (
                        <MeditocInfoField label="Folio de consulta:" value={consultaSeleccionada.sFolio} />
                    ) : (
                        <MeditocInfoField label="Usuario:" value={consultaSeleccionada.sCorreoPaciente} />
                    )}
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Nombre del paciente:" value={consultaSeleccionada.sNombrePaciente} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Hora de inicio:" value={consultaSeleccionada.sFechaProgramadaInicio} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Hora de fin:" value={consultaSeleccionada.sFechaProgramadaFin} />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
